import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlesPreview() {
  const latestArticles = articles.slice(0, 3);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-end justify-between mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              最新文章
            </h2>
            <p className="text-sm text-foreground-600">获取开云平台的最新指南与行业见解</p>
          </div>
          <Link
            to="/articles"
            className="mt-4 md:mt-0 flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/articles/${article.slug}`}
              className="group rounded-xl bg-background-100 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2">
                  <span>{article.date}</span>
                  <span>·</span>
                  <span>{article.author}</span>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{article.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}